import React, { Component } from "react";
import { connect } from "react-redux";
import { StorageApi } from "services/storage";
import { PASSWORD_UPDATE_STATUS } from "utils/StorageConstants";
import * as StorageUtils from "utils/StorageUtils";
import { updateShares } from "actions/storage";
import SharesLocation from "blox_components/Storage/ShareDetails/Components/SharesLocationComponent";
import ShareTrends from "blox_components/Storage/ShareDetails/Components/ShareTrends";
import ConfigDetails from "blox_components/Storage/ShareDetails/Components/ConfigDetails";
import VIPList from "blox_components/Storage/ShareDetails/Components/VIPList";
import BloxPage from "sub_components/Layout/BloxPage";
import ComponentWrapper from "sub_components/Layout/ComponentWrapper";
import { AddStorageDataProvider } from "context/AddStorageContext";
import { AddStorageModal } from "blox_components/Storage/AddStorage/AddStorageModal";
import { DIMENSIONS } from "services/layoutManager";
import { setHomeTour } from "actions/tour";
import { RESOLUTIONS } from "services/config";
import {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import { MENU as STORAGE_MENU } from "utils/StorageConstants";
import {
  SITE_PAGES,
  SITE_MODULES,
  SuccessMessage,
  ErrorMessage,
} from "utils/CommonConstants";
import { Permissions } from "services/permissions";
import { BloxButton } from "styled_components/Common/BloxButton";
import { CardScrollerVertical } from "styled_components/Common/CardScrollerVertical";
import { updatePermissions } from "actions/permissions";
import { JoyRideToolTip } from "styled_components/Common/JoyRideToolTip";
import { getUserPermissions, setUserPermissions } from "services/user";
import Joyride from "react-joyride-react-19";
import { TicketApi } from "services/ticket";
const CDN_URL = process.env.REACT_APP_CDN_URL;

const RedundancyIcon = `${CDN_URL}storage/Storage-mirror-arrows-inactive.svg`;
const SmallPublicIcon = `${CDN_URL}storage/Storage-public-icon-gray`;
const SmallPrivateIcon = `${CDN_URL}storage/Storage-private-icon-default.svg`;

const LAYOUT_CONFIG = {
  [RESOLUTIONS.LOW]: {
    storageDetails: { x: 0, y: 0, dim: DIMENSIONS.TWO_BY_FOUR },
    shareTrends: { x: 0, y: 19, dim: DIMENSIONS.TWO_BY_FOUR, customHeight: 53 },
    configurationDetails: { x: 5, y: 0, dim: DIMENSIONS.TWO_BY_SIX },
    activeVips: { x: 5, y: 19, dim: DIMENSIONS.FOUR_BY_SIX },
    shares: { x: 12, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    tourButton: { x: 0, y: 30, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.MED]: {
    storageDetails: { x: 0, y: 0, dim: DIMENSIONS.TWO_BY_FOUR },
    shareTrends: { x: 0, y: 29, dim: DIMENSIONS.TWO_BY_FOUR, customHeight: 50 },
    configurationDetails: { x: 5, y: 0, dim: DIMENSIONS.TWO_BY_SIX },
    activeVips: { x: 5, y: 29, dim: DIMENSIONS.FOUR_BY_SIX },
    shares: { x: 12, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    tourButton: { x: 0, y: 60, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.HIGH]: {
    storageDetails: { x: 0, y: 0, dim: DIMENSIONS.TWO_BY_FOUR },
    shareTrends: { x: 0, y: 50, dim: DIMENSIONS.TWO_BY_FOUR, customHeight: 80 },
    configurationDetails: { x: 5, y: 0, dim: DIMENSIONS.TWO_BY_SIX },
    activeVips: { x: 5, y: 50, dim: DIMENSIONS.FOUR_BY_SIX },
    shares: { x: 12, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    tourButton: { x: 0, y: 80, dim: DIMENSIONS.TWO_BY_TWO },
  },
};

class ShareDetailsPage extends Component {
  constructor() {
    super();
    this.state = {
      selected: null,
      shareName: " ",
      shares: null,
      share: null,
      whiteListModalOpen: false,
      passwordUpdateStatus: PASSWORD_UPDATE_STATUS.NOT_STARTED,
      storagePassword: null,
      hasStorageIPs: false,
      hasStorageSubnets: false,
      showModal: false,
      locations: null,
      availableVIPs: null,
      activeVIPs: null,
      security: null,
      tourClosed: false,
    };
  }
  componentDidMount() {
    const {
      updateModule,
      updatePage,
      addPageToBreadCrumbs,
      storage,
      company_info: { customer: { id } = {} },
      site,
      permissions,
      location,
      setHomeTour,
      tour: { runHomeTour: { runHomeTour } } = {},
    } = this.props;
    const { tourClosed } = this.state;
    const shares = storage?.shares;
    const search = location?.search;
    const buttonRendered = document.getElementById("add-share-button");

    if (
      buttonRendered &&
      buttonRendered.length !== 0 &&
      !runHomeTour &&
      !tourClosed
    ) {
      if (search.includes("tour=true")) {
        setHomeTour({ runHomeTour: true, action: "start" });
      }
    }

    updatePage(SITE_PAGES.STORAGE[STORAGE_MENU.DETAIL]);
    addPageToBreadCrumbs(
      SITE_PAGES.STORAGE[STORAGE_MENU.DETAIL],
      SITE_MODULES.STORAGE
    );
    if (site?.module !== "STORAGE" || !permissions?.permissions) {
      this.getModulePages();
    }
    updateModule(SITE_MODULES.STORAGE);
    this.checkForSelectedShare();
    if (id) {
      this.checkIPInventory(id);
    }

    if (shares && shares.length !== 0) {
      const sortedShares = StorageUtils.sortShares(shares);
      this.setState({ shares: sortedShares }, () => {
        this.setShare();
        this.getShareVIPs();
        this.getShareSecurity();
      });
    } else {
      this.getShares();
    }
  }

  getTicketType = (type) => {
    TicketApi.getTicketType(type)
      .then((response) => {
        if (response.status === 200 && response?.data && !response.data.error) {
          this.setState({ ticketType: response?.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  closeTour = (joyride) => {
    const { tourClosed } = this.state;
    const { setHomeTour } = this.props;

    const action = joyride?.action;
    if (
      (action === "close" && !tourClosed) ||
      (action === "reset" && !tourClosed) ||
      (action === "stop" && !tourClosed)
    ) {
      if (joyride?.index === 4 || joyride?.index === 5) {
        setHomeTour({ runHomeTour: false, action: "finish" });
        this.setState({ tourClosed: true });
      } else {
        setHomeTour({ runHomeTour: false, action });
        this.setState({ tourClosed: true });
      }
    }
  };

  getModulePages = async () => {
    const {
      updatePermissions,
      auth_status: {
        user: { id: userId },
      },
      company_info: {
        customer: { id: orgId },
      },
    } = this.props;
    //check cache
    const permissions = getUserPermissions("storage");
    if (!permissions) {
      const response = await Permissions.getModulePermissions(1, userId, orgId);
      if (response && !response.data.error) {
        setUserPermissions("storage", response.data.pages);
        updatePermissions(response.data.pages);
      }
    } else {
      updatePermissions(permissions);
    }
  };
  checkIPInventory = (orgId) => {
    StorageApi.checkIPInventory(orgId)
      .then((response) => {
        const validResponse =
          !response?.data?.error && response?.data?.hasStorageIPs;
        if (validResponse) {
          this.setState({
            hasStorageIPs: response?.data.hasStorageIPs,
            hasStorageSubnets: response?.data.hasStorageSubnets,
          });
        }
      })
      .catch(() => {});
  };

  getShares = async () => {
    const { updateShares } = this.props;
    const {
      company_info: {
        customer: { id },
      },
    } = this.props;
    await StorageApi.getAll(id)
      .then((response) => {
        const validResponse = !response.error && response.storages;
        if (validResponse) {
          const shares = StorageUtils.sortShares(response.storages);
          updateShares(shares);
          this.setState({ shares }, () => {
            this.setShare();
            this.getShareVIPs();
            this.getShareSecurity();
          });
        } else {
          this.setState({
            error: "Error pulling storage details",
            loading: false,
          });
        }
      })
      .catch((error) => console.log(error));
  };

  getShareId = () => {
    const { pathname } = window.location;
    const matches = pathname.split("/");

    if (matches) {
      const [, , , , shareNumber] = matches;

      if (shareNumber) {
        return shareNumber;
      }
    }
  };
  updateShare = () => {
    this.getShareVIPs();
  };

  setShare = async () => {
    const { selected } = this.state;
    const {
      company_info: {
        customer: { id },
      },
    } = this.props;
    if (!selected) return;
    try {
      const {
        storageDetails: { storage, locations },
        error: storageError,
      } = await StorageApi.get(selected, id);

      if (storage && !storageError) {
        this.setState({
          share: storage,
          locations,
        });
      } else {
        this.setState({
          error: "Error pulling storage details",
          loading: false,
        });
      }
    } catch (e) {
      console.log(e);
      this.setState({ error: "Error pulling storage details", loading: false });
    }
  };

  getShareSecurity = () => {
    const { selected } = this.state;
    const {
      company_info: {
        customer: { id },
      },
    } = this.props;
    if (!selected) return;
    StorageApi.getStorageSecurity(id, selected)
      .then((response) => {
        if (response.status === 200 && !response.data.error) {
          const { credentials } = response.data;
          this.setState({
            security: credentials,
          });
        } else {
        }
      })
      .catch(() => {});
  };

  getShareVIPs = async () => {
    const { selected } = this.state;
    const {
      company_info: {
        customer: { id },
      },
    } = this.props;
    if (!selected) return;
    try {
      const { availableVIPs, activeVIPs, error } = await StorageApi.getVIPs(
        selected,
        id
      );

      if (!error) {
        this.setState({
          availableVIPs,
          activeVIPs,
        });
      } else {
        this.setState({
          error: "Error pulling storage vip details",
          loading: false,
        });
      }
    } catch (e) {
      console.log(e);
      this.setState({ error: "Error pulling storage details", loading: false });
    }
  };

  checkForSelectedShare = async () => {
    const id = this.getShareId();

    if (id) {
      this.onStorageSelect(id);

      this.setState({ selected: id }, () => {
        this.setShare();
        this.getShareVIPs();
        this.getShareSecurity();
      });
    } else {
      const storageShareId = await this.getDefaultStorageShareId();

      if (storageShareId) {
        this.onStorageSelect(storageShareId);

        this.setState({ selected: storageShareId }, () => {
          this.setShare();
          this.getShareVIPs();
          this.getShareSecurity();
        });
      }
    }
  };
  getDefaultStorageShareId = async () => {
    const { storage } = this.props;
    const shares = storage?.shares;
    const {
      company_info: {
        customer: { id },
      },
    } = this.props;
    if (shares && shares.length !== 0) {
      const sortedShares = StorageUtils.sortShares(shares);
      return sortedShares[0].storage_id;
    } else {
      const { storages: shares } = await StorageApi.getAll(id);
      if (shares && shares.length) {
        const sortedShares = StorageUtils.sortShares(shares);
        return sortedShares[0].storage_id;
      }
    }
  };
  setShareName = (name) => {
    const shareName = name.replace("AUTH_", " ");

    this.setState({ shareName });
  };

  onStorageSelect = (selected) => {
    const { navigate, updatePage, addPageToBreadCrumbs, location } = this.props;
    const search = location?.search;
    let url = `/portal/storage/share_detail/${selected}`;

    if (search.includes("tour=true")) {
      url = `/portal/storage/share_detail/${selected}?tour=true`;
    }

    updatePage(SITE_PAGES.STORAGE[STORAGE_MENU.DETAIL]);
    addPageToBreadCrumbs(`Share #${selected}`, SITE_MODULES.STORAGE, url);
    this.setState({ share: null, loading: true });
    if (selected) {
      navigate(url);

      this.setState({ selected });
    }
  };
  componentDidUpdate(prevProps) {
    const { selected, tourClosed } = this.state;
    const {
      company_info: { customer: { id } = {} },
      tour: { runHomeTour: { runHomeTour } } = {},
      setHomeTour,
    } = this.props;
    const prevId = prevProps?.company_info?.customer?.id;
    const { pathname } = window.location;
    const matches = pathname.split("/");

    if (prevId !== id && id) {
      this.checkIPInventory(id);
    }
    const search = location?.search;
    const buttonRendered = document.getElementById("add-share-button");
    if (
      buttonRendered &&
      buttonRendered.length !== 0 &&
      !runHomeTour &&
      !tourClosed
    ) {
      if (search.includes("tour=true")) {
        setHomeTour({ runHomeTour: true, action: "start" });
      }
    }

    if (matches) {
      const [, , , , shareNumber] = matches;
      if (shareNumber && shareNumber !== selected) {
        this.setState({ selected: shareNumber }, () => {
          this.setShare();
          this.getShareVIPs();
          this.getShareSecurity();
        });
      }
    }
  }

  mapData = (shares) => {
    const { selected } = this.state;
    const data = [];

    if (!shares) {
      return data;
    }

    shares.map((share) => {
      const deleted =
        share.status === "deleted" || share.status === "pending_delete"
          ? " deleted"
          : "";
      const pending =
        share.status === "pending" || share.status === "processing"
          ? "pending"
          : "";
      const replication = share?.replication ? RedundancyIcon : null;
      const privacy = !share?.isPrivate ? SmallPublicIcon : SmallPrivateIcon;

      data.push({
        id: share?.storage_id,
        image: "image-url",
        name: share?.common_name,
        topLeftIcon: replication,
        topRightIcon: privacy,
        mainIcon: share?.icon,
        iconColor:
          parseInt(selected) === share.storage_id
            ? share?.icon_color
            : "#dfe1e1",
        deleted,
        pending,
      });
    });
    return data;
  };

  setShowModal = () => {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal });
  };
  onCancel = () => {
    const { setModalContent } = this.props;
    setModalContent("CLOSE");
  };
  setSubnetRequest = () => {
    const {
      company_info: {
        customer: { id },
      },
      setModalContent,
      checkIPInventory,
    } = this.props;
    this.onCancel();
    const button = (
      <BloxButton
        className="buttons41"
        id="okay"
        text="OKAY"
        module="storage"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );
    StorageApi.setSubnet(id)
      .then((response) => {
        const validResponse = !response?.data.error && response?.data.success;
        if (validResponse) {
          setModalContent("TIMEOUT_CLOSE", SuccessMessage, button);
          checkIPInventory(id);
        } else {
          setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
        }
      })
      .catch(() => {
        setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
      });
  };
  addSubnetModal = () => {
    const { hasStorageIPs, hasStorageSubnets } = this.state;
    const { setModalContent } = this.props;
    const button = (
      <BloxButton
        className="buttons41"
        id="set-subnet"
        text={hasStorageIPs && !hasStorageSubnets ? "OKAY" : "YES"}
        module="storage"
        enabled={true}
        onClick={this.setSubnetRequest}
        cypressId="set-subnet"
      />
    );
    let message =
      "You are out of new VIP's. Would you like for us to get more for you?";
    if (hasStorageIPs && !hasStorageSubnets) {
      message = "There are no available subnets. Please contact support.";
    }
    setModalContent(false, message, button);
  };

  render() {
    const {
      breakpoint,
      location,
      navigate,
      setModalContent,
      tour: { runHomeTour: { runHomeTour } } = {},
      site,
      company_info,
      company_info: {
        customer: { id },
      },
      auth_status,
      auth_status: {
        user: { id: userId },
        memberships,
      },
      permissions: pages,
    } = this.props;

    const {
      selected,
      shareName,
      share,
      locations,
      shares,
      loading,
      hasStorageIPs,
      hasStorageSubnets,
      showModal,
      activeVIPs,
      availableVIPs,
      security,
      ticketType,
    } = this.state;
    const module = site?.module;

    const hasMultipleAccounts =
      memberships && memberships.length > 1 ? true : false;

    const deleteStorageAccess = Permissions.checkComponentAccess(
      pages,
      "Share Detail",
      "delete-storage"
    );
    const ViewShares = Permissions.checkComponentAccess(
      pages,
      "Share Detail",
      "view-storage-list"
    );
    const ViewConfig = Permissions.checkComponentAccess(
      pages,
      "Share Detail",
      "view-storage-config"
    );
    const UpdateConfig = Permissions.checkComponentAccess(
      pages,
      "Share Detail",
      "update-storage-config"
    );
    const ViewVips = Permissions.checkComponentAccess(
      pages,
      "Share Detail",
      "view-storage-network"
    );
    const updateVIPsAccess = Permissions.checkComponentAccess(
      pages,
      "Share Detail",
      "update-storage-network"
    );
    const addShareAccess = Permissions.checkComponentAccess(
      pages,
      "Share Detail",
      "add-storage"
    );
    const ViewWhitelist = Permissions.checkComponentAccess(
      pages,
      "Share Detail",
      "view-storage-whitelist"
    );
    const ViewStorageTrends = Permissions.checkComponentAccess(
      pages,
      "Share Detail",
      "view-storage-trends"
    );
    const ViewStorageLocations = Permissions.checkComponentAccess(
      pages,
      "Share Detail",
      "view-storage-locations"
    );
    const UpdateWhitelist = Permissions.checkComponentAccess(
      pages,
      "Share Detail",
      "update-storage-whitelist"
    );
    const button = (
      <BloxButton
        id="add-share-button"
        text="ADD SHARE"
        module="storage"
        enabled={true}
        onClick={
          hasStorageIPs && hasStorageSubnets
            ? this.setShowModal
            : this.addSubnetModal
        }
        cypressId="add-storage"
        className="buttons41"
      />
    );
    const steps = [
      {
        content:
          "This is where you want to go if you need to add a share to your account. By clicking on Add Share, I will walk you through the process. Not to worry. It is a painless process.",
        showBackButton: false,
        disableBeacon: true,
        target: "#add-share-button",
        module: "storage",
      },
      {
        target: hasMultipleAccounts ? ".accounts-component" : null,
        content:
          "I see that more than one company is assigned to your account. If you hover your mouse in this area, I will show you the other company when we are done.",
        module: "storage",
      },
      {
        target: ".logout-component-section",
        content:
          "When was the last time you logged out? If you are like me and prefer a logout button, then after this tour, hover in this area, and I will display it for you.",
        module: "storage",
      },

      {
        content:
          "Wow! You made it to the end! Click finish, and I'll have another gem for you.",
        target: ".header-section",
        module: "storage",
        locale: { next: "Finish" },
        placement: "center",
      },
      {
        target: "#feedback-image",
        content:
          "I love feedback! You can tell me anything from any location on the site, including sending our developers a screenshot of the page you are on.",
        locale: { next: "Close" },
        noBackButton: true,
        showProgress: true,
        disableBeacon: true,
        module: "storage",
      },
      {
        target: "#start-tour-container-portal",
        content: "Don't forget I'm here if you need me.",
        locale: { next: "Finish" },
        showProgress: true,
        disableBeacon: true,
        module: "storage",
      },
    ];

    return (
      <BloxPage
        name="page storage-detail-page"
        layout={LAYOUT_CONFIG[breakpoint]}
        breakpoint={breakpoint}
        location={location}
      >
        <div key={`tourButton`} className="tourButton">
          {pages && (
            <Joyride
              steps={steps}
              continuous={true}
              tooltipComponent={JoyRideToolTip}
              run={runHomeTour}
              styles={{
                options: {
                  zIndex: 5000,
                },
              }}
              module={module}
              callback={this.closeTour}
              spotlightPadding={5}
              disableScrolling={true}
              disableBeacon={true}
              disableOverlayClose={true}
            />
          )}
        </div>
        <div key={`storageDetails`} className="storageDetails">
          {ViewStorageLocations && (
            <ComponentWrapper
              title={share?.common_name ? share?.common_name : ""}
              cypressId="share-title"
              hideBorder
            >
              <SharesLocation
                navigate={navigate}
                selected={selected}
                breakpoint={breakpoint}
                setShareName={this.setShareName}
                share={share}
                locations={locations}
                deleteStorageAccess={deleteStorageAccess}
                shares={shares}
                shareName={shareName}
                loading={loading}
                setModalContent={setModalContent}
                getShares={this.getShares}
                ticketType={ticketType}
              />
            </ComponentWrapper>
          )}
        </div>
        <div key={`shareTrends`} className="shareTrends">
          {ViewStorageTrends && (
            <ComponentWrapper title="Share Trends" hideBorder>
              <ShareTrends
                breakpoint={breakpoint}
                shares={shares}
                share={share}
                locations={locations}
                id={id}
              />
            </ComponentWrapper>
          )}
        </div>
        <div key={`configurationDetails`} className="configurationDetails">
          {ViewConfig && (
            <ComponentWrapper hideTitle hideBorder>
              <ConfigDetails
                share={share}
                navigate={navigate}
                security={security}
                setModalContent={setModalContent}
                updateConfig={UpdateConfig}
                loading={loading}
                refreshSecurity={this.getShareSecurity}
                breakpoint={breakpoint}
                ticketType={ticketType}
              />
            </ComponentWrapper>
          )}
        </div>
        <div key={`activeVips`} className="activeVips">
          {ViewVips && (
            <ComponentWrapper title="VIPs" hideBorder>
              <VIPList
                activeVIPs={activeVIPs}
                availableVIPs={availableVIPs}
                navigate={navigate}
                share={share}
                breakpoint={breakpoint}
                site={site}
                auth_status={auth_status}
                company_info={company_info}
                updateShare={this.updateShare}
                setModalContent={setModalContent}
                editWhitelist={UpdateWhitelist}
                viewWhitelist={ViewWhitelist}
                updateVIPsAccess={updateVIPsAccess}
                shares={shares}
                refreshShare={this.getShareVIPs}
                loading={loading}
                ticketType={ticketType}
              />
            </ComponentWrapper>
          )}
        </div>
        <div key={`shares`} className="shares">
          {ViewShares && (
            <ComponentWrapper title="My Shares" hideBorder>
              <CardScrollerVertical
                type="share"
                data={this.mapData(shares)}
                onClick={this.onStorageSelect}
                selected={selected}
                showButton={addShareAccess ? true : false}
                button={button}
              />
              <AddStorageDataProvider>
                <AddStorageModal
                  breakpoint={breakpoint}
                  setModalContent={setModalContent}
                  closeModal={this.setShowModal}
                  showModal={showModal}
                  navigate={navigate}
                  orgId={id}
                  userId={userId}
                  getShares={this.getShares}
                  ticketType={ticketType}
                  auth_status={auth_status}
                />
              </AddStorageDataProvider>
            </ComponentWrapper>
          )}
        </div>
      </BloxPage>
    );
  }
}

function mapStateToProps(state) {
  return {
    site: state.site_tracking,
    auth_status: state.auth_status,
    company_info: state.company_info,
    storage: state.storage,
    permissions: state.permissions,
    tour: state.tours,
  };
}

export default connect(mapStateToProps, {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
  updateShares,
  updatePermissions,
  setHomeTour,
})(ShareDetailsPage);
